import Vue from 'vue';
import { path } from 'ramda';
/**
 * 快速创建一个modal
 *
 * @param {*} component 组件
 * @param {*} props 属性
 * @param {*} parent 父组件
 * @returns {*} 返回组件实例
 */
export function quickCreateModal(component, props, parent = null) {
    const { onClose, ...restProps } = props || {};
    function close() {
        document.body.removeChild(vm.$el); // eslint-disable-line no-use-before-define
        vm.$destroy(); // eslint-disable-line no-use-before-define
        onClose && onClose();
    }
    const vm = new Vue({
        render(h) {
            return h(component, {
                props: {
                    ...restProps,
                    close
                }
            });
        },
        watch: {
            path() {
                close();
            }
        },
        computed: {
            path() {
                return path(['$route', 'path'], this);
            }
        },
        parent
    }).$mount();
    document.body.appendChild(vm.$el);
    const comp = vm.$children[0];
    return comp;
}
